export const CSS_CLASSES = {
  MESSAGE_ROOT: "message",
  MESSAGE_INLINE: "message-inline",

  MESSAGE_ICON_SMALL: "message-icon-small",
  MESSAGE_ICON_MEDIUM: "message-icon-medium",
  MESSAGE_ICON_LARGE: "message-icon-large",

  MESSAGE_ICON_INFO: "message-icon-info",
  MESSAGE_ICON_SUCCESS: "message-icon-success",
  MESSAGE_ICON_ERROR: "message-icon-error",
  MESSAGE_ICON_WARNING: "message-icon-warning",
  MESSAGE_ICON_INACTIVE: "message-icon-inactive",

  MESSAGE_CONTENT: "message-content",
  MESSAGE_CONTENT_SMALL: "message-content-small",
  MESSAGE_CONTENT_MEDIUM: "message-content-medium",
  MESSAGE_CONTENT_LARGE: "message-content-large",

  MESSAGE_CONTENT_INFO: "message-content-info",
  MESSAGE_CONTENT_SUCCESS: "message-content-success",
  MESSAGE_CONTENT_ERROR: "message-content-error",
  MESSAGE_CONTENT_WARNING: "message-content-warning",
  MESSAGE_CONTENT_INACTIVE: "message-content-inactive",

  MESSAGE_LABEL: "message-label",
  MESSAGE_LABEL_NO_MATCH_COLOR: "message-label-no-match-color",

  MESSAGE_TEXT: "message-text",
  MESSAGE_TEXT_NO_MATCH_COLOR: "message-text-no-match-color",
};
